import { getRuntimeConfig } from '@/lib/config/runtime-config'

/*
 * Auth0 SPA configuration for Admin South Downs, read from this deployment's
 * /app-config.json (ADR-034). The client is the Admin South Downs application
 * in that environment's Auth0 tenant (VIS-442), whose Application Login URI is
 * this app's origin, so Auth0's set-password page can return invitees here.
 * The client ID is a public SPA identifier (Authorization Code + PKCE, no
 * client secret). There is no fallback tenant.
 *
 * TECH-DEBT: ADR-034 decision 3 (in-memory token cache, no refresh-token
 * fallback) is not yet applied; see auth-provider.tsx.
 */
export function getAuth0Config() {
  return getRuntimeConfig().auth0
}
